<template>
  <div class="retreat">
    <topTitle title="退换货"></topTitle>
    <div class="goodsList">
      <div class="item">
        <p>
          2019-10-02 10:02:02
          <span>已提交</span>
        </p>
        <div>
          <div>
            <img src="../../assets/temporaryPicture/sp1.png" alt />
          </div>
          <p>SDHC9E15-210电磁炉防水智能电…</p>
        </div>
      </div>
      <div class="item">
        <p>
          2019-10-02 10:02:02
          <span>已提交</span>
        </p>
        <div>
          <div>
            <img src="../../assets/temporaryPicture/sp2.png" alt />
          </div>
          <p>SDHC9E15-210电磁炉防水智能电…</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topTitle from "../../components/topTitle.vue";
// import { Swipe, SwipeItem, Tab, Tabs, Dialog} from 'vant';
export default {
  name: "retreat",
  data() {
    return {};
  },
  components: {
    topTitle
  },
  created(){

  },
  methods: {}
};
</script>


<style scoped lang='less'>
.retreat {
  .goodsList {
    .item {
      width: 714px;
      height: 250px;
      background: #fff;
      margin: 20px auto;
      border-radius: 8px;

      padding: 26px 31px;
      margin-bottom: 10px;
      > p {
        display: flex;
        justify-content: space-between;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        span {
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 25, 25, 1);
        }
      }
      > div {
        margin-top: 25px;
        display: flex;
        > div {
          width: 136px;
          height: 136px;
          margin-right: 28px;
        }
        p {
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          flex: 1;
        }
      }
    }
  }
}
</style>


